<template>
  <div class="content-page" v-if="applitInfo">
    <div class="bd">
      <div class="content">
        <div class="block-title" style="display: flex">
          <div class="inner">模板列表</div>
          <div style="color: red; padding: 2px 0 0 5px; font-size: 12px">
            提示: 点击模板图片可放大预览
          </div>
        </div>
        <div class="tabs">
          <el-tabs
            v-model="editableTabsValue"
            type="card"
            @tab-click="show_upsPage"
            class="sub"
          >
            <el-tab-pane
              :key="item.name"
              v-for="item in tabsList"
              :label="item.categoryName"
              :id="item.goodsCategoryId"
              :name="item.categoryName"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="content-container">
          <div v-if="templateList.length > 0" class="list">
            <div class="template-item" v-for="(item, index) in templateList" :key="index">
              <img class="template-img" preview :src="item.templateImage" alt srcset />
              <div class="template-info">
                <p>
                  <span class="templateName">{{ item.templateName }}</span>
                </p>
                <p>
                  <span>更新时间:</span>
                  {{ item.modifyTime.split(".")[0] }}
                </p>
                <p class="version">
                  <span>版本：</span>
                  {{ item.templateVersion }}
                </p>
                <div class="flex-row-between" style="margin-top: 8px" @click.stop>
                  <el-button type="primary" size="small" @click="selTemplate(index)"
                    >选择</el-button
                  >
                  <!-- <el-button class="button5" size="small" @click="preview(item)"
                    >预览</el-button
                  > -->
                  <img src="@/assets/img/appltTemplate/open.png" @click="open(index)" />
                </div>
              </div>
              <div class="small_mask" v-show="templateIndex1 == index">
                <p class="template-title">模板功能介绍</p>
                <p>{{ item.templateIntroduce }}</p>
              </div>
              <img
                src="@/assets/img/appltTemplate/isUse.png"
                v-show="templateIndex == index"
                class="isUse-img"
              />
              <img
                src="@/assets/img/appltTemplate/isChoose.png"
                v-show="templateIndex2 == index"
                class="isUse-img"
              />
            </div>
          </div>
          <div v-else>暂无模板</div>
        </div>
        <div class="action-bottom">
          <el-button type="primary" @click="selectedTemplate">确定</el-button>
        </div>
      </div>
      <!-- <viewer :images="photo">
        <img
          v-for="(src, index) in photo"
          :src="src"
          :key="index"
          :onerror="errorImg"
          class="big-img"
        />
      </viewer>
      <img
        src="@/assets/img/appltTemplate/close.png"
        v-show="mask"
        class="close-img"
        @click="close"
      />
      <div class="mask" v-show="mask"></div> -->
    </div>
  </div>
</template>

<script>
import {
  getApplitTemplateList,
  selectedTemplate,
  selectedTemplateAlipay,
  experienceCreateAlipay,
  selectedTemplateDY,
} from "@/api";
import { commonFuc } from "@/mixins/commonFuc";
import { mapState } from "vuex";
export default {
  mixins: [commonFuc],
  data() {
    return {
      templateList: [],
      templateIndex: null,
      tabsList: [
        { goodsCategoryId: "", categoryName: "全部" },
        { goodsCategoryId: 1, categoryName: "服装配饰" },
        { goodsCategoryId: 2, categoryName: "生鲜果蔬" },
        { goodsCategoryId: 3, categoryName: "日用百货" },
        { goodsCategoryId: 4, categoryName: "美容护肤" },
        { goodsCategoryId: 5, categoryName: "蛋糕烘焙" },
        { goodsCategoryId: 6, categoryName: "数码家电" },
        { goodsCategoryId: 7, categoryName: "母婴亲子" },
        { goodsCategoryId: 8, categoryName: "其他行业" },
        { goodsCategoryId: 9, categoryName: "自定义装修" },
      ],
      editableTabsValue: "全部",
      photo: [],
      errorImg: "@/assets/img/appltTemplate/close.png",
      mask: false,
      templateIndex1: -1,
      isUse: false,
      templateIndex2: null,
    };
  },
  computed: {
    ...mapState({
      applitInfo: (state) => state.applitInfo,
      appltType: (state) => state.appltType,
    }),
  },
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    appltType() {
      console.log(1);
      this.getPageData();
    },
  },
  mounted() {
    this.getPageData();
    console.log(localStorage.switchLive, 1111);
  },
  methods: {
    show_upsPage(e) {
      this.getApplitTemplateList(e.$attrs.id);
      this.templateIndex1 = -1;
    },
    getPageData() {
      this.getApplitTemplateList();
    },
    getApplitTemplateList(templateTypes = "") {
      getApplitTemplateList({
        pageNo: 1,
        row: 999,
        miniAppPlatform:
          this.appltType == "wx"
            ? 1
            : this.appltType == "TINYAPP"
            ? 2
            : this.appltType == "IOTAPP"
            ? 3
            : 4,
        templateTypes: templateTypes,
        // isLive: localStorage.switchLive == "true" ? 1 : 0,
      })
        .then((res) => {
          if (res.code == 1) {
            this.templateList = res.data;
            console.log(
              this.applitInfo.miniAppTemplateId,
              "this.applitInfo.miniAppTemplateId"
            );
            if (this.applitInfo.miniAppTemplateId) {
              var index = this.templateList.findIndex((item) => {
                return item.miniAppTemplateId == this.applitInfo.miniAppTemplateId;
              });
              if (index !== -1) {
                this.templateIndex = index;
                this.isUse = true;
              } else {
                this.templateIndex = null;
                this.isUse = false;
              }
            }
          } else if (res.code == -1) {
            this.templateList = [];
          } else {
          }
        })
        .catch((e) => {
          console.log("err", e);
          // this.getApplitTemplateList(templateTypes);
        });
    },
    selectedTemplate() {
      let idx =
        this.templateIndex2 > 0
          ? this.templateIndex2
          : this.templateIndex2 == 0
          ? 0
          : this.templateIndex;
      // if (!idx) {
      //   this.$notify({
      //     title: "提示",
      //     message: "请先选择模板",
      //     type: "warning",
      //     duration: 1000,
      //   });
      //   return
      // }
      if (this.appltType == "wx") {
        selectedTemplate({
          miniAppTemplateId: this.templateList[idx].miniAppTemplateId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.templateIndex2 = null;
            this.$emit("getMiniAppInfo");
            this.$router.push({
              path: "/applt/info",
            });
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else if (this.appltType == "dy") {
        selectedTemplateDY({
          miniAppTemplateId: this.templateList[idx].miniAppTemplateId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.templateIndex2 = null;
            this.$emit("getMiniAppInfo");
            this.$router.push({
              path: "/applt/info",
            });
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        selectedTemplateAlipay({
          miniAppTemplateId: this.templateList[idx].miniAppTemplateId,
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.templateIndex2 = null;
            setTimeout(() => {
              experienceCreateAlipay();
            }, 2e4);
            this.$emit("getMiniAppInfo");
            this.$router.push({
              path: "/applt/info",
            });
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      }
    },
    selTemplate(index) {
      console.log(index);
      // this.templateIndex = index;
      this.templateIndex1 = -1;
      this.templateIndex2 = index;
      console.log(this.templateIndex2);
    },
    preview(item) {
      // this.mask = true;
      // this.photo = [];
      // this.photo.push(item.templateImage);
      this.templateIndex1 = -1;
    },
    close() {
      this.mask = false;
      this.photo = [];
    },
    open(index) {
      this.templateIndex1 = index;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: hidden;
  .bd {
    position: relative;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    .content {
      height: 100%;
      .tabs {
        padding: 20px 0;
        box-sizing: border-box;
      }
      .content-container {
        height: calc(100% - 135px);
        overflow: auto;
        .list {
          padding-bottom: 80px;
        }
      }
    }
    .el-radio {
      text-align: center;
      margin: 10px;
    }
    .template-item {
      display: inline-block;
      text-align: center;
      margin: 10px;
      width: 200px;
      height: 356px;
      position: relative;
      label {
      }
      .template-img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 1px solid #ccc;
      }
      .isUse-img {
        position: absolute;
        top: -10px;
        right: -10px;
        z-index: 4;
      }
      .template-info {
        position: absolute;
        bottom: 0;
        // width: 200px;
        font-size: 13px;
        text-align: left;
        // background: rgba(0, 0, 0, 0.6);
        // color: #fff;
        line-height: 30px;
        // top: 204px;
        // left: -100px;
        height: 150px;
        background: #fff;
        color: #b8b8b8;
        padding: 8px 5px;
        box-sizing: border-box;
        z-index: 1;
        left: 1px;
        width: calc(100% - 2px);
        .templateName {
          font-size: 16px;
          color: #000;
          font-weight: 500;
        }
        .version {
          border-bottom: 1px solid #ececec;
          padding-bottom: 5px;
          box-sizing: border-box;
        }
      }
    }
    .close-img {
      position: absolute;
      z-index: 5;
      top: 70px;
      left: 51%;
    }
    .big-img {
      width: 380px;
      height: 676px;
      position: absolute;
      z-index: 5;
      top: 10%;
      left: 30%;
    }
    .action-bottom {
      background: #fff;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 20px 0;
      text-align: center;
      z-index: 3;
    }
  }
}
.button5 {
  width: 56px;
  height: 32px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
  margin-right: 35px;
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 10px;
  box-sizing: border-box;
}
.mask {
  position: absolute;
  z-index: 4;
  top: 0;
  left: 0;
  width: calc(100vw);
  height: calc(100vh);
  background-color: rgba(101, 101, 101, 0.6);
}
.small_mask {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  width: 202px;
  height: 208px;
  background-color: rgba(101, 101, 101, 0.6);
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
  color: #f6f3f3;
  .template-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
    box-sizing: border-box;
    color: #fff;
  }
}
</style>
